// extracted by mini-css-extract-plugin
export default {"infoWrapper":"infoWrapper-GceQh","bubbleUpTitle":"bubbleUpTitle-UxIcb","arrow":"arrow-eqU8T"};